import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=b464af32&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=b464af32&prod&scoped=true&lang=css"
import style1 from "./marketplace.vue?vue&type=style&index=1&id=b464af32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b464af32",
  null
  
)

export default component.exports